import createPersistedState from 'vuex-persistedstate'
import config from '@/data/config'

export default createPersistedState({
  key: config.localStorageKey,
  paths: ['account.token', 'account.user']
})
